'use client'

import { useState } from 'react'

import { useMutation } from '@apollo/client'
import { Button } from '@canyon/ui/Button'
import { Card, CardContent } from '@canyon/ui/Card'
import { Dialog, DialogContent, DialogFooter } from '@canyon/ui/Dialog'
import { Input } from '@canyon/ui/Input'
import { Label } from '@canyon/ui/Label'
import { CheckCircle, User } from '@phosphor-icons/react'

import { RequestResumeReviewDialog_RequestResumeReviewDocument } from '@gql/graphql'

interface IRequestResumeReviewDialogProps {
  open: boolean
  resumeId?: string
  setOpen: (open: boolean) => void
}

export const RequestResumeReviewDialog = ({
  open,
  resumeId,
  setOpen,
}: IRequestResumeReviewDialogProps) => {
  const [notes, setNotes] = useState('')
  const [requestResumeReview, { loading: isRequestResumeReviewLoading }] = useMutation(
    RequestResumeReviewDialog_RequestResumeReviewDocument,
    {
      variables: {
        id: resumeId || '',
        notes,
      },
    }
  )

  const handleRequestResumeReview = async () => {
    const { data } = await requestResumeReview()
    if (data?.requestResumeReview) {
      window.open(data?.requestResumeReview, '_self')
    }
    setOpen(false)
  }

  const RESUME_REVIEW_FEATURES = [
    'Resume Review from a verified professional in your industry',
    'Guaranteed ATS-approved resume for your job backed by our data',
    'Review within one business day',
  ]

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogContent title="Request Resume Review" titleIcon={<User />}>
        <Card className="mb-2 w-full border border-blue-500">
          <CardContent className="relative flex h-full flex-col gap-2 px-3 py-4">
            <div className="text-lg font-semibold">Resume Review</div>
            <div className="text-2xl font-semibold text-white">$20</div>
            <div className="text-muted-foreground flex flex-col gap-2 text-sm">
              {RESUME_REVIEW_FEATURES?.map((feature, index) => (
                <div className="flex flex-row items-center gap-2" key={index}>
                  <CheckCircle size={14} /> {feature}
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
        <Label className="text-muted-foreground">Notes</Label>
        <Input
          className="mt-1"
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Add notes for your reviewer"
          value={notes}
        />

        <DialogFooter>
          <Button
            loading={isRequestResumeReviewLoading}
            onClick={handleRequestResumeReview}
            variant="cta"
          >
            Request
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
